import ModalBase from "./ModalBase";
import React from "react";
import { useModal } from "../context/ModalContext";

interface PromptModalProps {
  header: string;
  message: string;
  value?: string;
  note?: string;
  onConfirm: (value: string) => void;
  onCancel: () => void;
}

export default function PromptModal({
  header,
  message,
  value: initialValue = "",
  note,
  onConfirm,
  onCancel,
}: PromptModalProps) {
  const { hideModal } = useModal();
  const [value, setValue] = React.useState("");
  const handleConfirm = () => {
    onConfirm(value);
    hideModal();
  };

  const handleCancel = () => {
    onCancel();
    hideModal();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  return (
    <ModalBase
      header={header}
      body={
        <>
          <p>{message}</p>
          <input type="text" onChange={onChange} defaultValue={initialValue} />
          {note && <p className="note">{note}</p>}
        </>
      }
      footer={
        <>
          <button className="loa-button" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="loa-button loa-button-primary"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </>
      }
    />
  );
}
